// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-info[data-v-7e23072d] {\n  color: white;\n  width: 500px;\n  font-weight: normal;\n}[dir] .message-info[data-v-7e23072d] {\n  background: #ea7037;\n  border-radius: 10px 10px 10px 10px;\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
